import moment from 'moment';
import get from 'lodash/get';

import formatBorrowerName from '../../../../../../helpers/formatBorrowerName';

/* eslint-disable no-shadow */
export default function formatResults(result, type, isLender) {
  const rules = {
    loans: {
      parts: [
        [
          result._lender?.pref_use_lender_loan_numbers &&
          isLender &&
          result.loan_number
            ? 'loan_number'
            : 'pixel_loan_number',
        ],
        ['_property.address_line_1', ' |'],
        ['_property.city', ','],
        ['_borrower_primary.name', ' |'],
        ['_borrower_primary.entity_name', ' ||'],
      ],
      link: (result) => `/loans/${result.id}?tab=Loan`,
    },

    invoices: {
      parts: [
        ['pixel_invoice_number'],
        ['status', ' -'],
        ['_loan._property.address_line_1', ' |'],
        ['_loan._property.city', ','],
      ],
      link: (result) =>
        `/loans/${result.loan_id}/invoices/${result.id}?tab=Invoice`,
    },

    properties: {
      parts: [
        ['address_line_1'],
        ['city', ','],
        ['_loan.pixel_loan_number', ' |'],
      ],
      link: (result) => `/loans/${result._loan.id}?tab=Property`,
    },

    bills: {
      parts: [
        ['pixel_bill_number'],
        ['status', ' - '],
        ['_loan._property.address_line_1', ' | '],
        ['_loan._property.city', ', '],
      ],
      link: (result) => `/loans/${result._loan.id}/bills/${result.id}?tab=Bill`,
    },

    borrowers: {
      parts: [
        ['first_name', 'last_name'],
        ['entity_name', ' '],
      ],
      link: (result) => {
        const firstLoan = get(result, '_loans[0]');
        return firstLoan ? `/loans/${firstLoan.id}?tab=Borrowers` : '';
      },
      subParts: {
        source: '_loans',
        parts: [['_property.address_line_1'], ['_property.city', ',']],
        link: (result) => `/loans/${result.id}?tab=Borrowers`,
      },
    },

    lenders: {
      parts: [['name']],
      link: (result) => `/lenders/${result.id}?tab=Lender`,
    },

    payments: {
      parts: [
        ['_loan._property.address_line_1'],
        ['_loan._property.city', ','],
        ['amount', ' | '],
        ['status', ','],
      ],
      link: (result) =>
        `/loans/${result._loan.id}/payments/${result.id}?tab=Payment`,
    },

    /*   transfers: {
    parts: [
      ['pixel_number'],
      ['date', ' - ', (value) => moment(value).format('M/D/YY')],
      ['amount', ' - ', (value) => (value ? `$${formatCurrency(value)}` : '')],
    ],
    link: (result) => `/transfers/${result.id}`,
  }, */

    transfer_bills: {
      parts: [
        ['pixel_number'],
        ['date', ' - ', (value) => moment(value).format('M/D/YY')],
        ['_loan._property.address_line_1', ' | '],
        ['_loan._property.city', ','],
      ],
      link: (result) =>
        `/loans/${result._loan.id}/transfer-bills/${result.id}?tab=TransferBills`,
    },

    vendors: {
      parts: [['name']],
      link: (result) => `/vendors/${result.id}?tab=Vendor`,
    },

    bill_payments: {
      parts: [['pixel_number']],
      link: (result) => `/bill-payments/${result.id}`,
    },

    insurances: {
      parts: [
        ['policy_number'],
        ['_agent.name', ' | '],
        ['\n'],
        ['_loan._borrower_primary', '', (value) => formatBorrowerName(value)],
        ['_loan._property.address_line_1', ' | '],
      ],
      link: (result) =>
        `/loans/${result.loan_id}/insurances/${result.id}?tab=Insurance`,
    },
  };

  return rules[type];
}
